import React, { Component } from 'react'
import { Card, Grid } from '@material-ui/core'
import { KeyboardArrowRight} from '@material-ui/icons'
import Anchor from 'Components/common/Anchor';

class ReplenishmentSCCard extends Component {

  render() {
    const { scDetails } = this.props

    return (
	    <Card className='replenishment-sc-card' onClick={ this.props.chooseSC.bind(this, scDetails) }>
	      	<Grid className='replenishment-content' container spacing={0}>
		      	<Grid className='left-content-grid' item xs={11}>
		      		<Grid className='sc-details' container spacing={0} justify={'space-evenly'}>
		      			<Grid className='sc-name' item xs={11}>
			      			<span>{scDetails.name}</span>
			      		</Grid>
		      			<Grid className='sc-address' item xs={11}>
			      			<span>{scDetails.address}</span>
			      		</Grid>
			      	</Grid>
			    </Grid>
		    	<Grid className='right-content-grid' item xs={1}>
		  			<Anchor>
		  				<KeyboardArrowRight/>
		  			</Anchor>
		    	</Grid>
	    	</Grid>
	    </Card>
	    )
	}
}


export default ReplenishmentSCCard
